module.exports = __webpack_public_path__ + "img/logo.41fe8f9e.png";